module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI0MCIgaGVpZ2h0PSI0MCIgdmlld0JveD0iMCAwIDQwIDQwIj48cGF0aCBkPSJNOSAzaDE2LjVMMzQgMTEuNVYzNWEyIDIgMCAwIDEtMiAySDlhMiAyIDAgMCAxLTItMlY1YTIgMiAwIDAgMSAyLTJ6IiBmaWxsPSIjRTY0OTgwIi8+PHBhdGggZD0iTTI1LjUgM3Y2LjVhMiAyIDAgMCAwIDIgMkgzNHoiIGZpbGw9IiNmZmYiIGZpbGwtb3BhY2l0eT0iLjQ1Ii8+PHBhdGggZD0iTTI1IDE3LjV2MTBhMi42IDIuNiAwIDEgMS0xLjgtMi40N1YyMS4ybC02IDEuNXY2LjhhMi42IDIuNiAwIDEgMS0xLjgtMi40N1YxOS41eiIgZmlsbD0iI2ZmZiIvPjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/disk/audio.svg
// module id = 1298
// module chunks = 8